import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import './contact.css'

function Contact() { 
    let SUBMIT_ACTION = `https://formsubmit.co/a0050acecae5ae5e26f9c68d0f217498`

    return (
            
            <section className='Contact-Section' id="contact">
                <Helmet>
                    <title>Haris Khan | Front-End Web Developer</title>
                </Helmet>
                <h1>Lets Discuss Work</h1>
                <form className='form-container' action={SUBMIT_ACTION} method="POST">
                <div className='form-group'>
                    <label>Name:</label><br/>
                    <input
                        className='input-bar'
                        type="text"
                        name="name"
                        />
                    </div>

                    <div className='form-group'>
                        <label>Email:</label><br/>
                        <input
                            className='input-bar'
                            type="email"
                            name="email"
                            />
                    </div>

                    <div className='form-group'>
                        <label>Message:</label><br/>
                        <textarea
                            className='input-bar msg-area'
                            type="textarea"
                            name="message"
                            />
                    </div>

                    <button className='submit-btn' type='submit'>
                        Submit
                    </button>
                </form>
            </section>
    )
}

export default Contact
